module.exports = __webpack_public_path__ + "static/inspospotr-extraimg2@2x-min-91c55e9bf4e1a20c95d24550173e40a3.png";